import { environment } from '@environments/environment';

const url = environment.apiUrl;

export const SERVICES_CONFIG = {
  permissions: {
    findbyusername: {
      url: url + '/rbac/users/v1/findPermissionsByUsername',
      context: 'permissions.findbyusername'
    }
  },
  authentication: {
    sendBackList: {
      url: url + '/rbac/blacklist/v1/save',
      context: 'rbac.sendblacklist'
    }
  },
  balanceInterface: {
    attachmentbalanceinterface: {
      url: url + '/accountings/v1/attachment-balance-interface',
      context: 'accounting.attachmentbalanceinterface'
    }
  },
  channels: {
    findall: {
      url: url + '/channels',
      context: 'channels.findall'
    }
  },
  commissions: {
    add: {
      url: url + '/commissions',
      context: 'commissions.add'
    },
    delete: {
      url: url + '/commissions',
      context: 'commissions.delete'
    },
    findall: {
      url: url + '/commissions',
      context: 'commissions.findall'
    },
    update: {
      url: url + '/commissions',
      context: 'commissions.update'
    }
  },
  customers: {
    findbydocument: {
      url: url + '/customers/v1/find-by-document-and-type',
      context: 'customers.findbydocument'
    }
  },
  masterTransfers: {
    attachmentmastergiros: {
      url: url + '/accountings/v1/attachment-master-giros',
      context: 'accounting.attachmentmastergiros'
    }
  },
  movementInterface: {
    attachmentmovementreport: {
      url: url + '/accountings/v1/attachment-movement-report-history',
      context: 'accounting.attachmentmovementreport'
    }
  },
  transactionsEvents: {
    attachmenttransactionsevents: {
      url: url + '/accountings/v1/attachment-transactions-events',
      context: 'accounting.attachmenttransactionsevents'
    }
  },
  limits: {
    add: {
      url: url + '/amlcontrol/v1/aml',
      context: 'amlcontrol.add'
    },
    delete: {
      url: url + '/amlcontrol/v1/aml',
      context: 'amlcontrol.delete'
    },
    findall: {
      url: url + '/amlcontrol/v1/aml',
      context: 'amlcontrol.findall'
    },
    update: {
      url: url + '/amlcontrol/v1/aml',
      context: 'amlcontrol.update'
    }
  },
  roles: {
    add: {
      url: url + '/rbac/roles/v1',
      context: 'roles.add'
    },
    delete: {
      url: url + '/rbac/roles/v1',
      context: 'roles.delete'
    },
    findall: {
      url: url + '/rbac/roles/v1',
      context: 'roles.findall'
    },
    findbyid: {
      url: url + '/rbac/roles/v1',
      context: 'roles.findbyid'
    },
    update: {
      url: url + '/rbac/roles/v1',
      context: 'roles.update'
    }
  },
  segments: {
    add: {
      url: url + '/amlcontrol/v1/segments',
      context: 'segments.add'
    },
    delete: {
      url: url + '/amlcontrol/v1/segments',
      context: 'segments.delete'
    },
    findall: {
      url: url + '/amlcontrol/v1/segments',
      context: 'segments.findall'
    },
    findwithoutamllimit: {
      url: url + '/amlcontrol/v1/segments/without-amllimit/',
      context: 'segments.findwithoutamllimit'
    },
    update: {
      url: url + '/amlcontrol/v1/segments',
      context: 'segments.update'
    }
  },
  transfersCustomer: {
    findbycustomerdate: {
      url: url + '/transfers/find-by-customer-date/v1',
      context: 'transfers.findbycustomerdate'
    }
  },
  transfersReference: {
    canupdatecellphone: {
      url: url + '/transfers/girupdate/v1/can-update-cellphone',
      context: 'transfers.canupdatecellphone'
    },
    canavoid: {
      url: url + '/transfers/avoid/v1/can-avoid',
      context: 'transfers.canavoid'
    },
    avoid: {
      url: url + '/transfers/avoid/v1/avoid',
      context: 'transfers.avoid'
    },
    canreverseadm: {
      url: url + '/transfers/can-reverse-adm',
      context: 'transfers.canreverseadm'
    },
    reverseadm: {
      url: url + '/transfers/reverse-adm',
      context: 'transfers.reverseadm'
    },
    findbyreference: {
      url: url + '/transfers/find-by-reference/v1',
      context: 'transfers.findbyreference'
    },
    updatecellphone: {
      url: url + '/transfers/girupdate/v1/update-cellphone',
      context: 'transfers.updatecellphone'
    },
    updatedocument: {
      url: url + '/transfers/girupdate/v1/update-document',
      context: 'transfers.updatedocument'
    }
  },
  users: {
    add: {
      url: url + '/rbac/users/v1',
      context: 'users.add'
    },
    delete: {
      url: url + '/rbac/users/v1',
      context: 'users.delete'
    },
    findall: {
      url: url + '/rbac/users/v1',
      context: 'users.findall'
    },
    update: {
      url: url + '/rbac/users/v1',
      context: 'users.update'
    }
  },
  logReport: {
    attachmenttransactionslogevents: {
      url: url + '/accountings/v1/attachment-modification-log',
      context: 'accounting.attachmentmodificationlog'
    }
  }  ,
  totalsCost: {
    attachmenttotalcostsreport: {
      url: url + '/accountings/v1/attachment-total-costs-report',
      context: 'accounting.attachmenttotalcostsreport'
    },
    attachmensentinelreport: {
      url: url + '/accountings/v1/attachment-sentinel-report',
      context: 'accounting.attachmensentinelreport'
    }
  }
};
